import { AxiosInstance } from 'axios';
import { HouseKeepingRoomServiceStatusService } from '../../../../services';

export interface HouseKeepingRoomServiceStatusServiceModel {
  getAll: ReturnType<typeof HouseKeepingRoomServiceStatusService.getAll>;
  exportPDF: ReturnType<typeof HouseKeepingRoomServiceStatusService.exportPDF>;
  update: ReturnType<typeof HouseKeepingRoomServiceStatusService.update>;
  getRoomDetails: ReturnType<typeof HouseKeepingRoomServiceStatusService.getRoomDetails>;
  buldUpdateRoomServiceStatus: ReturnType<
    typeof HouseKeepingRoomServiceStatusService.bulkUpdateRoomServiceStatus
  >;
  bulkReinstateRoomServiceStatus: ReturnType<
    typeof HouseKeepingRoomServiceStatusService.bulkReinstateRoomServiceStatus
  >;
}

export const initServiceStatusRootService = (
  axios: AxiosInstance
): HouseKeepingRoomServiceStatusServiceModel => ({
  getAll: HouseKeepingRoomServiceStatusService.getAll(axios),
  exportPDF: HouseKeepingRoomServiceStatusService.exportPDF(axios),
  update: HouseKeepingRoomServiceStatusService.update(axios),
  getRoomDetails: HouseKeepingRoomServiceStatusService.getRoomDetails(axios),
  buldUpdateRoomServiceStatus:
    HouseKeepingRoomServiceStatusService.bulkUpdateRoomServiceStatus(axios),
  bulkReinstateRoomServiceStatus:
    HouseKeepingRoomServiceStatusService.bulkReinstateRoomServiceStatus(axios),
});
